import * as TypeGraphQL from "type-graphql";
export var EventImportance;
(function (EventImportance) {
    EventImportance["LOW"] = "LOW";
    EventImportance["MEDIUM"] = "MEDIUM";
    EventImportance["HIGH"] = "HIGH";
})(EventImportance || (EventImportance = {}));
TypeGraphQL.registerEnumType(EventImportance, {
    name: "EventImportance",
    description: undefined,
});
//# sourceMappingURL=EventImportance.js.map